export default __webpack_public_path__ + "static/media/pin_verde.c8e14020.png";